// extracted by mini-css-extract-plugin
export default {"headerRightContainer":"Header__headerRightContainer___V5XQH","curriculumDropdown":"Header__curriculumDropdown___bV3p2"};